import { http } from "./Config";
import settings from "@/settings";
export default {
  
  get: () => {
    return http.get(
        settings.usuarioAutenticado.GET_INDEX +
        "?empresa=" +
        settings.usuarioAutenticado.EMPRESA +
        "&cliente=" +
        settings.usuarioAutenticado.CLIENTE
    );
  },
};
